<template>
<div class="faq">
  <v-container>
    <v-row justify="center" align="center">
      <v-col md="10" sm="12" class="text-center">
        <p class="text-h6 text-md-h4 white--text text-center mb-6 ">Ответы на вопросы</p>
        <v-expansion-panels focusable>
          <v-expansion-panel v-for="(item, i) in questions" :key="i">
            <v-expansion-panel-header>{{item.question}}</v-expansion-panel-header>
            <v-expansion-panel-content class="text-left pt-4">
              {{item.answer}}
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
  </v-container>
</div>
</template>

<script>
  import questions from "../../courses/child_faq.js"
  export default {
    data: () => ({
    questions: questions
  })
  };
</script>

<style lang="scss" scoped>
.faq {
  background: linear-gradient(45deg, #2d3e56,#67c293 );
}
</style>